const plans = [
  {
    header: 'Тестування',
    old: 499,
    price: "Безкоштовно",
    features: [
      { text: "Безкоштовний тест", show: true },
    ],
    color: 'blue',
    buttonLabel: 'Почати безкоштовно',
  },
  {
    header: 'Онбординг',
    old: 1999,
    price: "150 грн",
    features: [
      { text: "Разова сплата сервісного", show: true },
      { text: 'Допомога з отриманням офферу', show: true },

    ],
    color: 'pink',
    buttonLabel: 'Після успішного тестування',
  },
  {
    header: 'Оффбоардинг',
    old: 25,
    price: "7% від зарплати",
    features: [
      { text: "Після проходження випробувального терміну", show: true },
      { text: 'На протязі 12 місяців', show: true },
      { text: 'Допомога на випробувальному терміні', show: true },
    ],
    color: 'magenta',
    buttonLabel: 'Після успішного офферу',
  },
];

export default plans;
